import { map, pathOr } from 'ramda';

import { storableError } from '../../util/errors';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { types as sdkTypes } from '../../util/sdkLoader';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { isNilOrEmpty } from '../../util/validators';

const { UUID } = sdkTypes;

// ================ Action types ================ //

export const FETCH_LISTINGS_REQUEST = 'app/MyFavoritesPage/FETCH_LISTINGS_REQUEST';
export const FETCH_LISTINGS_SUCCESS = 'app/MyFavoritesPage/FETCH_LISTINGS_SUCCESS';
export const FETCH_LISTINGS_ERROR = 'app/MyFavoritesPage/FETCH_LISTINGS_ERROR';

// ================ Reducer ================ //

const initialState = {
  pagination: null,
  queryInProgress: false,
  queryListingsError: null,
  queryListingsSuccess: null,
};

const myFavoritesPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_LISTINGS_REQUEST:
      return {
        ...state,
        queryInProgress: true,
        queryListingsError: null,
        queryListingsSuccess: false,
      };
    case FETCH_LISTINGS_SUCCESS:
      return {
        ...state,
        queryInProgress: false,
        queryListingsSuccess: true,
      };
    case FETCH_LISTINGS_ERROR:
      // eslint-disable-next-line no-console
      console.error(payload);
      return { ...state, queryInProgress: false, queryListingsError: payload, queryListingsSuccess: false };

    default:
      return state;
  }
};

export default myFavoritesPageReducer;


// ================ Action creators ================ //

// This works the same way as addMarketplaceEntities,
// but we don't want to mix own listings with searched listings
// (own listings data contains different info - e.g. exact location etc.)

export const queryListingsRequest = queryParams => ({
  type: FETCH_LISTINGS_REQUEST,
  payload: { queryParams },
});

export const queryListingsSuccess = () => ({
  type: FETCH_LISTINGS_SUCCESS,
});

export const queryListingsError = e => ({
  type: FETCH_LISTINGS_ERROR,
  error: true,
  payload: e,
});


export const queryMyFavoritesListings = () => async (dispatch, getState, sdk) => {
  dispatch(queryListingsRequest());
  await dispatch(fetchCurrentUser());
  const { currentUser } = getState().user;
  const myFavorites =
    pathOr([], ['attributes', 'profile', 'protectedData', 'myFavorites'], currentUser);
  if (isNilOrEmpty(myFavorites)) return dispatch(queryListingsSuccess());

  Promise.all(map((favoriteListingId) => {
    const listingId = new UUID(favoriteListingId);
    sdk.listings.show({
      id: listingId,
      include: ['images'],
      'fields.image': ['variants.landscape-crop', 'variants.landscape-crop2x'],
      'limit.images': 1,
    })
      .then(response => {
        dispatch(addMarketplaceEntities(response));
        return response;
      })
      .catch(e => {
        dispatch(queryListingsError(storableError(e)));
        throw e;
      });
  }, myFavorites));
  return dispatch(queryListingsSuccess());
};



// WEBPACK FOOTER //
// ./src/containers/MyFavoritesPage/index.duck.js